import axios from 'axios'
import * as Config from '../../config'

const state = {
    users: {
        current_page: 1,
        data: [],
    },
    event: {},
    categorySelect: '',
    searchStatus: false,
    eventSearch: [],
}

const actions = {

    loadEventsByDate({commit, dispatch}, date) {
        commit('LOAD_EVENTS_BY_DATE')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/filterbydate/' + date)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_BY_DATE_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_BY_DATE_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_BY_DATE_FAIL');
                    reject();
                })
        })
    },
    loadEventByID({commit, dispatch}, idevent) {
        commit('LOAD_EVENTS_BY_ID')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/find/' + idevent)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_BY_ID_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_BY_ID_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_BY_ID_FAIL');
                    reject();
                })
        })
    },
    loadEventByIdCategory({commit, dispatch}, idcategory) {
        commit('LOAD_EVENTS_BY_ID_CATEGORY')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/filterby/id_event_category/' + idcategory)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_BY_ID_CATEGORY_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_BY_ID_CATEGORY_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_BY_ID_CATEGORY_FAIL');
                    reject();
                })
        })
    },
    loadEventsOutstanding({commit, dispatch}, from) {
        // loadEventsOutstanding({commit, dispatch}, id_type_event) {
        commit('LOAD_EVENTS_OUTSTANDING')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userevent/outs/event', from)
            // axios.get(Config.apiPath + 'event/filterby/id_type_event/' + id_type_event)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_OUTSTANDING_OK', response.data.data);
                            resolve(response.data.data);
                        } else {
                            commit('LOAD_EVENTS_OUTSTANDING_FAIL');
                            reject();
                        }
                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_OUTSTANDING_FAIL');
                    reject();
                })
        })
    },
    loadEventsPleasure({commit, dispatch}, id) {
        commit('LOAD_EVENTS_PLEASURE')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/filterbypleasure/' + id)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_PLEASURE_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_PLEASURE_FAIL')
                            reject()
                        }
                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_PLEASURE_FAIL');
                    reject();
                })
        })
    },
    loadEvents({commit, dispatch}) {
        commit('LOAD_EVENTS')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/approve/all')
                .then(
                    response => {
                        commit('LOAD_EVENTS_OK')
                        resolve(response.data.data)

                    })
                .catch(error => {
                    commit('LOAD_EVENTS_FAIL')
                    reject(error)
                })
        })
    },
    loadEvents_Outstanding({commit, dispatch}, form) {
        commit('LOAD_EVENTS')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'event/outstanding/all', form)
                .then(
                    response => {
                        commit('LOAD_EVENTS_OK')
                        resolve(response.data.data)

                    })
                .catch(error => {
                    commit('LOAD_EVENTS_FAIL')
                    reject(error)
                })
        })
    },
    loadCategoriesEvent({commit, dispatch}) {
        commit('LOAD_CATEGORIES')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'category/event/approve')
                .then(
                    response => {
                        commit('LOAD_CATEGORIES_OK')
                        resolve(response.data.data)

                    })
                .catch(error => {
                    commit('LOAD_CATEGORIES_FAIL')
                    reject(error)
                })
        })
    },
    myEvent({commit, dispatch}) {
        commit('LOAD_EVENTS')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'event/my/all')
                .then(
                    response => {
                        commit('LOAD_EVENTS_OK')
                        resolve(response.data.data)

                    })
                .catch(error => {
                    commit('LOAD_EVENTS_FAIL')
                    reject(error)
                })
        })
    },
    loadEventFavorite({commit, dispatch}, iduser) {
        commit('LOAD_EVENTS_FAVORITE')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'userevent/favorite/' + iduser)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_FAVORITE_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_FAVORITE_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_FAVORITE_FAIL');
                    reject();
                })
        })
    },
    loadEventShare({commit, dispatch}, iduser) {
        commit('LOAD_EVENTS_SHARE')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'userevent/share/' + iduser)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_EVENTS_SHARE_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_EVENTS_SHARE_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_EVENTS_SHARE_FAIL');
                    reject();
                })
        })
    },
    changeActive({commit, dispatch}, form) {
        commit('CHANGE_ACTIVE_EVENT')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userevent/change/active', form)
                .then(
                    response => {
                        commit('CHANGE_ACTIVE_EVENT_OK')
                        resolve(response.data)

                    })
                .catch(error => {
                    commit('CHANGE_ACTIVE_EVENT_FAIL')
                    reject(error.data)
                })
        })


    },
    OutEvent({commit, dispatch}, form) {
        commit('CHANGE_ACTIVE_EVENT')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userevent/out/event', form)
                .then(
                    response => {
                        commit('CHANGE_ACTIVE_EVENT_OK')
                        resolve(response.data)

                    })
                .catch(error => {
                    commit('CHANGE_ACTIVE_EVENT_FAIL')
                    reject(error.data)
                })
        })


    },
    StoreFavorite({commit, dispatch}, form) {
        commit('STORE_FAVORITE')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userevent/save', form)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('STORE_FAVORITE_OK')
                            resolve(response.data)
                        } else {
                            commit('STORE_FAVORITE_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                    commit('STORE_FAVORITE_FAIL')
                    reject(error.data)
                })
        })


    },
    StoreShare({commit, dispatch}, form) {
        commit('STORE_SHARE')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userevent/save', form)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('STORE_SHARE_OK')
                            resolve(response.data)
                        } else {
                            commit('STORE_SHARE_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                    commit('STORE_SHARE_FAIL')
                    reject(error.data)
                })
        })


    },
    StoreEvent({commit, dispatch}, form) {
        commit('STORE_EVENT')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'event/save', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('STORE_EVENT_OK')
                            resolve(response.data)
                        } else {
                            commit('STORE_EVENT_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                    commit('STORE_EVENT_FAIL')
                    reject(error.data)
                })
        })


    },
    selectCategory({commit, dispatch}, form) {
        commit('SELECT_CATEGORY', form.value)
    },
    ChangeStatusSearch({commit, dispatch},form) {
        commit('CHANGE_STATUS_SEARCH',form)
    },
    SearchEvent({commit, dispatch}, form) {
        commit('SEARCH_EVENTS')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'event/search/items', form)
                .then(
                    response => {
                        if (response.data.code === 200) {
                            commit('SEARCH_EVENTS_OK')
                            resolve(response.data)
                        } else {
                            commit('SEARCH_EVENTS_FAIL')
                            reject(response.data)
                        }

                    })
                .catch(error => {
                    commit('SEARCH_EVENTS_FAIL')
                    reject(error.data)
                })
        })
    }

}

const mutations = {

    LOAD_EVENTS_BY_DATE_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_BY_ID_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_OUTSTANDING(state, events) {
        state.events = events
    },
    LOAD_EVENTS_OUTSTANDING_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_PLEASURE(state, events) {
        state.events = events
    },
    LOAD_EVENTS_PLEASURE_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_FAVORITE(state, events) {
        state.events = events
    },
    LOAD_EVENTS_FAVORITE_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_SHARE_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_BY_ID_CATEGORY_OK(state, events) {
        state.events = events
    },
    LOAD_EVENTS_BY_ID_CATEGORY(state, events) {
        state.events = events
    },
    SELECT_CATEGORY(state, value) {
        state.categorySelect = value
    },
    CHANGE_STATUS_SEARCH(state,value) {
        state.searchStatus = value.status
        state.eventSearch = value.arrayEvent
    },

}

export default {
    state,
    actions,
    mutations
}
